package br.com.vvrefeicoes.portal.feature.juridico

import kotlinx.datetime.LocalDate

internal fun String.toBrazilianDate(): String {
    val parts = split('-')
    return if (parts.size == 3 && parts[0].length == 4) {
        "${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}"
    } else {
        this
    }
}

internal fun String.toApiDate(): String {
    val parts = split('/')
    return if (parts.size == 3 && parts[2].length == 4) {
        "${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}"
    } else {
        this
    }
}

internal fun String.toLocalDateOrNull(): LocalDate? = runCatching { LocalDate.parse(this) }.getOrNull()
